/*
 * @Author: wangshengqiang
 * @Date: 2022-01-03 14:02:08
 * @LastEditTime: 2022-01-03 14:37:47
 * @LastEditors: wangshengqiang
 * @Description: 自定义确认项显示组件Map关系
 */
import CertAttachmentConfirm from './certAttachmentConfirm/index.js';
export default {
  certAttachment: CertAttachmentConfirm
};